module.exports = __webpack_public_path__ + "img/violet_005.12a57321.png";